import { render, staticRenderFns } from "./Seller.vue?vue&type=template&id=548852c0&scoped=true"
import script from "./Seller.vue?vue&type=script&lang=js"
export * from "./Seller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548852c0",
  null
  
)

export default component.exports